import { Me } from '@streamster/shared/api/types';
import { getAuthStore } from '@streamster/shared/screens/auth/auth.utils';

const defaultConfig: Record<string, { default: boolean; admin: boolean }> = {
  billingEnabled: { default: true, admin: false },
  // DEPRECATED — no route reads this any more; the Freshdesk "Support" nav item
  // it gated was removed on 2026-07-22. Delete with the rest of the teardown,
  // see streamster-account/docs/freshdesk-removal.md.
  supportEnabled: { default: false, admin: true },
};

const getConfigValue = (key: string, user?: Me): boolean => {
  const config = defaultConfig[key];
  const auth = getAuthStore();

  if (!config) {
    return false;
  }

  if (config.admin && !auth.webAuth?.admin) {
    return false;
  }

  if (config.admin && auth.webAuth?.admin) {
    return true;
  }

  return config.default;
};

export { getConfigValue };
